import { useMutation } from '@tanstack/react-query'

import { signInUser } from '@/api/mutate'

function useSignInMutation() {
  return useMutation({ mutationFn: signInUser() })
}

export default useSignInMutation
